'use client';

import type { PropsWithChildren } from 'react';
import React, { useContext, useMemo } from 'react';

import type { ContextualData } from '../contextualData';
import { emptyContextualData, mergeContextualData } from '../contextualData';

const ContextualDataContext = React.createContext<ContextualData>(emptyContextualData);

/** Gets current contextual data. */
export const useContextualData: () => ContextualData = () => {
  return useContext(ContextualDataContext);
};

/** Adds contextual data. The data will be appended to any parent data. */
export const AddContextualData: React.FC<PropsWithChildren<Partial<ContextualData>>> = ({
  children,
  user,
  data,
  adClickContext,
  campaignContext,
  customerContext,
  exclusiveOffersContext,
  leadContext,
  sellDirectContext,
}) => {
  const parent = useContextualData();
  const value = useMemo(
    () =>
      mergeContextualData(parent, {
        user,
        data,
        adClickContext,
        campaignContext,
        customerContext,
        exclusiveOffersContext,
        leadContext,
        sellDirectContext,
      }),
    [
      parent,
      user,
      data,
      adClickContext,
      campaignContext,
      customerContext,
      exclusiveOffersContext,
      leadContext,
      sellDirectContext,
    ],
  );
  return React.createElement(ContextualDataContext.Provider, { value }, children);
};
